export default __webpack_public_path__ + "static/media/roncoli.916f6278.jpeg";